<script setup>
import { ref, defineProps, defineEmits } from 'vue'
import 'vue-advanced-cropper/dist/style.css'
import { useCustomerStore } from '@/core/store/CustomerStore'
import MenuButton from './Components/Menu-Button.vue'
import ModalButtons from './Components/Modal-Menue.vue'
import DataView from './Components/Data-View.vue'

const BLOCK_NAME = "comparsion_block";
const channel = ref(useCustomerStore().getCustomer.customer);

// local variables
const editDialog = ref(false)
// define props
const props = defineProps({
    template_type: { type: String, required: true },
    index: { type: Number, required: false },
    data: { type: Object, required: true },
    image_library: { type: Object, required: false },
    workflow_id: { type: String, required: true }
})
// define emits
const emits = defineEmits(['blockCallback'])

// fields
const template = ref(BLOCK_NAME)


const html_content_col1 = ref(props.data.html_content_col1);
const html_content_col2 = ref(props.data.html_content_col2);
const text_subtitle_col1 = ref(props.data.text_subtitle_col1);
const text_subtitle_col2 = ref(props.data.text_subtitle_col2);
const text_headline = ref(props.data.text_headline)
const edit = ref(false)

// functions
const edit_block = () => {
    editDialog.value = true
    edit.value = false
}

const save_block = () => {

    emits('blockCallback',
        {
            "template_data": {
                "template": template.value,
                "html_content_col1": html_content_col1.value,
                "html_content_col2": html_content_col2.value,
                "text_subtitle_col1": text_subtitle_col1.value,
                "text_subtitle_col2": text_subtitle_col2.value,
                "text_headline": text_headline.value,
            },
            "action": "save",
            "index": props.index
        }
    )
    editDialog.value = false
}

const delete_block = () => {
    emits('blockCallback',
        {
            "action": "delete",
            "index": props.index
        }
    )
    editDialog.value = false
}

const add_block = () => {
    emits('blockCallback',
        {
            "template_data": {
                "template": template.value,
                "html_content_col1": "",
                "html_content_col2": "",
                "text_subtitle_col1": "",
                "text_subtitle_col2": "",
                "text_headline": "",
            },
            "action": "add",
            "index": props.index
        }
    )
}
const toggleDialog = () => {
    editDialog.value = false
}
</script>

<template>
    <!--------------------------------------------------->
    <!------------------ Menu View ---------------------->
    <!--------------------------------------------------->
    <MenuButton v-if="props.template_type == 'menu'" :add_block="add_block" button="pi-sliders-h" name="Comparsion Block" />

    <!--------------------------------------------------->
    <!------------------ Data View ---------------------->
    <!--------------------------------------------------->
    <DataView v-if="props.template_type == 'data'" :edit_block="edit_block" name="Comparsion Block">
        <div class="container mx-auto px-2 py-2">
            <h2 class="text-xl font-semibold mb-2 text-center">{{ text_headline }}</h2>
            <div class="flex">
                <div class="bg-white p-4 rounded w-1/2">
                    <div class="text-sm">Col 1</div>
                    <div class="text-start font-bold">{{ text_subtitle_col1 }}</div>
                    <span v-html="html_content_col2"></span>
                </div>

                <div class="bg-white p-4 rounded w-1/2">
                    <div class="text-sm">Col 2</div>
                    <div class="text-start font-bold">{{ text_subtitle_col2 }}</div>
                    <span v-html="html_content_col1"></span>
                </div>
            </div>
        </div>
    </DataView>
    <!--------------------------------------------------->
    <!------------------- Dialogs ----------------------->
    <!--------------------------------------------------->

    <!--------------------------------------------------->
    <!------------------- Edit Block -------------------->
    <!--------------------------------------------------->
    <Dialog v-model:visible="editDialog" :style="{ width: '80%' }" header="Block bearbeiten" :modal="true" class="p-fluid">

        <div class="">
            <ModalButtons :saveBlock="save_block" :deleteBlock="delete_block" :toggleDialog="toggleDialog" />
            </div>
            <div>
            <div class="my-3">
                <label for="text_headline">Überschrift</label>
                <InputText v-model="text_headline" id="text_text_headline" type="text" :autoResize="true" />
            </div>

            <div class="flex">
                <div class="my-3 mr-2">
                    <div class="text-base font-bold">Col 1</div>
                    <div class="my-2">
                        <InputText v-model="text_subtitle_col1" id="text_subtitle_col1" type="text" placeholder="Überschrift Block 1" />
                    </div>
                    <Editor editorStyle="" class="h-80" v-model="html_content_col1">
                    </Editor>
                </div>

                <div class="my-3 mr-2">
                    <div class="text-base font-bold">Col 2</div>
                    <div class="my-2">
                        <InputText v-model="text_subtitle_col2" id="text_subtitle_col2" type="text" placeholder="Überschrift Block 2" />
                    </div>
                    <Editor editorStyle="" class=" h-80" v-model="html_content_col2">
                    </Editor>
                </div>
            </div>
        </div>
    </Dialog>
</template>